export default __webpack_public_path__ + "static/media/card_premium_4.0f803784.svg";